export default __webpack_public_path__ + "static/media/deleteBinIcon.24cfddcc.svg";